import * as React from "react";
function CartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.925 6.4c-.075-.075-.15-.15-.3-.15H6.375L6 4.3c0-.15-.225-.3-.375-.3h-2.25C3.15 4 3 4.15 3 4.375s.15.375.375.375h1.95l1.8 9.15c.225 1.2 1.35 2.1 2.55 2.1H18.3c.225 0 .375-.15.375-.375s-.15-.375-.375-.375H9.75c-.6 0-1.2-.3-1.5-.825l10.95-1.5c.15 0 .3-.15.3-.3l1.5-6s0-.15-.075-.225zm-2.1 5.85l-10.95 1.425-1.35-6.75H20.1l-1.275 5.325zM9.375 16.75c-1.05 0-1.875.825-1.875 1.875S8.325 20.5 9.375 20.5s1.875-.825 1.875-1.875-.825-1.875-1.875-1.875zm0 3c-.6 0-1.125-.525-1.125-1.125S8.775 17.5 9.375 17.5s1.125.525 1.125 1.125-.525 1.125-1.125 1.125zM16.875 16.75c-1.05 0-1.875.825-1.875 1.875s.825 1.875 1.875 1.875 1.875-.825 1.875-1.875-.825-1.875-1.875-1.875zm0 3c-.6 0-1.125-.525-1.125-1.125s.525-1.125 1.125-1.125S18 18.025 18 18.625s-.525 1.125-1.125 1.125z"
  }));
}
const ForwardRef = React.forwardRef(CartIcon);
export default ForwardRef;